/* eslint-disable react/require-default-props */

import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { Button } from '../../../../components/Buttons/Button/Button';
import { makeMetricsLogEvent } from '../../../../../ReduxStorage/Metrics/manualEventDispatchers';

/* global _OL_ORIGIN */

export class _ProfileHeaderMessageButton extends PureComponent {
  static propTypes = {
    user: ImmutablePropTypes.map,
    activeUser: ImmutablePropTypes.map,
    metricsLogEvent: PropTypes.func.isRequired,
  };

  onMessageButtonClick = () => {
    const { user, activeUser, metricsLogEvent } = this.props;
    const userProfileName = user.get('profileName');
    const activeUserProfileName = activeUser.get('profileName');
    const coversationID = [userProfileName, activeUserProfileName]
      .sort()
      .join('_with_');
    const url = `${_OL_ORIGIN}/accounts/conversations/${coversationID}/`;

    metricsLogEvent('ProfileMessage-Sent');
    window.location.href = url;
  };

  render() {
    const { user } = this.props;
    return user.get('fullName') ? (
      <Button
        label={`Send ${user.get('fullName')} a message`}
        icon="envelope"
        onClick={this.onMessageButtonClick}
        className="header-message-button"
      />
    ) : null;
  }
}

export const ProfileHeaderMessageButton = connect(undefined, {
  metricsLogEvent: makeMetricsLogEvent,
})(_ProfileHeaderMessageButton);
